import { PHASES1026_RESULTS } from "../actions/ActionType";

export const initialState = {
  types: []
};
export const phases1026Reducer = (type = initialState, action) => {
  switch (action.type) {
    case PHASES1026_RESULTS:
      return {
        phases1026: action.payload
      };
    default:
      return type;
  }
};
